import { Enumify } from "enumify-ts";
class WeightUnitType extends Enumify() {
    description;
    static KG = new WeightUnitType("Kilogram");
    static GM = new WeightUnitType("Gram");
    static TN = new WeightUnitType("Tonne");
    static _ = WeightUnitType._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    static selectOptionsArray(shortUnits = false) {
        return WeightUnitType.values.map(it => {
            return {
                label: (shortUnits) ? it.key.toLowerCase() : it.description,
                value: it.key
            };
        });
    }
}
export default WeightUnitType;
